export enum FirebaseErrorCodes {
  NotFound = 'file-not-exists',
  PermissionDenied = 'permission-denied',
}

export enum FirebaseErrorMessages {
  NotFound = 'No such file in collection',
}
